<input
    #search
    matInput
    [attr.disabled]="searchPlaceholder === 'Loading...' ? 'disabled' : null"
    name="keyword"
    [placeholder]="searchPlaceholder"
    [(ngModel)]="keyword"
    (blur)="searchActive = false"
    (focus)="searchActive = true"
    (keyup)="handleTyping()"
/>
<button
    *ngIf="keyword || (searchPlaceholder !== 'Loading...' && searchPlaceholder !== 'Search')"
    (click)="search.focus(); handleClearClick()"
    class="clear-button"
>
    ✕
</button><br>
<main
    *ngIf="keyword"
    [ngStyle]="{ left: left + 'px', width: width + 'px' }"
>
    <button
        *ngFor="let option of foundOptions"
        (click)="handleLocationClick(option)"
    >
        {{ option.tag }}: {{ option.name }}
    </button>
</main>
